import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useQuery } from '@tanstack/react-query'
import type { ReferredUsersResponse } from 'types/api'

export const partnerReferredUsersQueryKey = ['partner-referred-users']

export function usePartnerReferredUsers() {
  async function getPartnerReferredUsers() {
    const response = await apiClient.get<ReferredUsersResponse>(
      SNA_PREFIX + 'referrals/referred-users'
    )
    return response.data
  }

  return useQuery({
    queryFn: getPartnerReferredUsers,
    queryKey: [...partnerReferredUsersQueryKey]
  })
}
